import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/components/ui/aos-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/components/ui/header/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/mnt/data/opt/node/penzu-next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/public/images/penzu-icon-red.png");
